import { createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    ref: "playbackRef",
    class: "w-full h-3 flex flex-row items-center cursor-pointer",
    onMouseenter: _cache[0] || (_cache[0] = function ($event) {
      return $setup.toggleDragBtnDisplay(true);
    }),
    onMouseleave: _cache[1] || (_cache[1] = function ($event) {
      return $setup.toggleDragBtnDisplay(false);
    })
  }, [_createCommentVNode(" 进度条 "), _createElementVNode("div", {
    class: "h-[2px]",
    style: _normalizeStyle({
      width: "".concat($setup.currentPercentage, "%"),
      backgroundColor: $props.bgColor
    })
  }, null, 4
  /* STYLE */
  ), _createCommentVNode(" 进度条拖拽按钮 "), _createElementVNode("div", {
    id: "playback-drag-btn",
    class: "w-3 h-3 rounded-md",
    style: _normalizeStyle({
      backgroundColor: $props.bgColor,
      display: !$setup.dragBtnDisplay ? 'none' : 'initial'
    })
  }, null, 4
  /* STYLE */
  )], 544
  /* HYDRATE_EVENTS, NEED_PATCH */
  );
}